import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import axios from 'axios';
import { getProviders } from './Providers';
import { Formik } from 'formik';
import { object, string, boolean } from 'yup';
import Layout from './Layout';
import { Link } from 'react-router-dom';
import Input from '../components/form/FormikInput';
import Select from '../components/form/FormikSelect';
import Checkbox from '../components/form/FormikCheckbox';
import { ReactComponent as CheckIcon } from '../svg/check.svg';
import { ReactComponent as ChevronLeft } from '../svg/chevron-left.svg';

const addUser = (data) => {
    return axios.request({
        url: `${process.env.REACT_APP_API_URL}/authorized/users`,
        method: 'POST',
        data
    });
};

export const StatusButton = ({
    success = null,
    disabled = false,
    label = 'Submit',
    successLabel = 'Success',
    onClick = null
}) => (
    <button
        className={classnames('btn btn-sm', {
            'btn-primary': success === null,
            'btn-success': success
        })}
        type="submit"
        disabled={disabled}
        onClick={onClick}
    >
        {success === null ? (
            label
        ) : (
            <>
                <CheckIcon width="1em" height="1em" /> {successLabel}
            </>
        )}
    </button>
);

const userSchema = object().shape({
    firstname: string().required('First Name is required'),
    lastname: string().required('Last Name is required'),
    email: string().email().required('Email is required'),
    provider: string().required('You must select a Provider'),
    passportadmin: boolean().default(false),
    readonly: boolean().default(true)
});

const defaultUserData = {
    firstname: '',
    lastname: '',
    email: '',
    provider: '',
    passportadmin: false,
    readonly: true
};
const UserAdd = () => {
    const [providers, setProviders] = useState([]);
    const [success, setSuccess] = useState(null);

    useEffect(() => {
        getProviders().then((resp) => setProviders(resp.results));
    }, []);

    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        let { firstname, lastname, email, provider, readonly, passportadmin } = values;

        setSubmitting(true);
        addUser({
            firstname,
            lastname,
            email: email.toLowerCase(),
            providerid: Number(provider),
            readonly,
            passportadmin
        })
            .then((resp) => {
                setSubmitting(false);
                setSuccess(true);
                setTimeout(() => {
                    setSuccess(null);
                    resetForm();
                }, 3000);
            })
            .catch(() => {
                setSubmitting(false);
                setSuccess(null);
            });
    };

    return (
        <Layout>
            <p>
                <Link className="alt-link" to="/users">
                    <ChevronLeft width="1em" height="1em" />
                    Back to Users
                </Link>
            </p>
            <div className="page-header">
                <h1>Add User</h1>
            </div>

            <div className="row">
                <Formik initialValues={defaultUserData} validationSchema={userSchema} onSubmit={handleSubmit}>
                    {({
                        values,
                        touched,
                        errors,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        resetForm,
                        setFieldValue
                    }) => (
                        <form
                            className="col-sm-6"
                            onSubmit={handleSubmit}
                            onReset={() => resetForm(defaultUserData)}
                            noValidate
                        >
                            <div className="row">
                                <div className="col-xs-12 col-md-6">
                                    <Input
                                        id="firstname"
                                        label="First Name"
                                        value={values.firstname}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        touched={!!touched.firstname}
                                        errors={errors.firstname}
                                        required
                                    />
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <Input
                                        id="lastname"
                                        label="Last Name"
                                        value={values.lastname}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        touched={!!touched.lastname}
                                        errors={errors.lastname}
                                        required
                                    />
                                </div>
                            </div>

                            <Input
                                id="email"
                                type="email"
                                label="Email"
                                value={values.email}
                                onChange={(ev) => {
                                    const email = ev.target.value;
                                    setFieldValue('email', email);
                                    if (!email.includes('inaudio.com')) {
                                        setFieldValue('passportadmin', false);
                                    }
                                }}
                                onBlur={handleBlur}
                                touched={!!touched.email}
                                errors={errors.email}
                                required
                            />

                            <Select
                                id="provider"
                                label="Provider"
                                value={values.provider}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                touched={!!touched.provider}
                                errors={errors.provider}
                                defaultEmpty
                                required
                            >
                                {providers.map((provider) => (
                                    <option key={provider.id} value={provider.id}>
                                        {provider.name}
                                    </option>
                                ))}
                            </Select>

                            <div className="mb-4">
                                <Checkbox
                                    label="Passport Admin?"
                                    id="passportadmin"
                                    checked={values.passportadmin}
                                    onChange={handleChange}
                                    disabled={!values.email.includes('spotify.com')}
                                />
                                <Checkbox
                                    label="Read Only?"
                                    id="readonly"
                                    checked={values.readonly}
                                    onChange={handleChange}
                                />
                            </div>

                            <StatusButton
                                label="Add"
                                successLabel="User Added!"
                                success={success}
                                disabled={isSubmitting}
                            />
                            <button className="btn btn-sm text-muted" type="reset">
                                Clear
                            </button>
                        </form>
                    )}
                </Formik>
            </div>
        </Layout>
    );
};

export default UserAdd;
